<p-calendar [(ngModel)]="value" [disabled]="config.disabled" [dateFormat]="config.dateFormat" [minDate]="config.minDate"
    [maxDate]="config.maxDate" (onSelect)="dateChange()" (onInput)="dateChange()" [readonlyInput]="config.readonlyInput"
    [showIcon]="true" [showTime]="config.showTime" [placeholder]="placeholder" [hourFormat]="config.hourFormat"
    [showSeconds]="config.showSeconds" [yearNavigator]="config.showNavigator" [monthNavigator]="config.showNavigator"
    [yearRange]="config.yearRange" [appendTo]="config.appendTo">
</p-calendar>